export default [
    {
        path: '/family-site-categories',
        name: 'family-site-categories',
        component: () => import('../../pages/familySiteCategories/IndexPage.vue'),
        meta: {
            title: 'Service Categories',
            requiresAuth: true,
        },
    },
]
